define([
    'system/domain/entity/sync-state'
], function(
    SyncStateModel
    ) {
    /**
     * 複数の SyncStateModel をラップして扱うための Model
     */
    return Backbone.Model.extend({
        initialize: function(params) {
            this._models = new Backbone.Collection(params.models);
            this.listenTo(this._models, 'change', this.update);
            this.update();
        },

        update: function() {
            if(this.isConflict()) {
                this.set('state', SyncStateModel.States.conflict);
            }
            if(this.isSyncing()) {
                this.set('state', SyncStateModel.States.syncing);
            }
            if(this.isUnsync()) {
                this.set('state', SyncStateModel.States.unsync);
            }
            if(this.isSynced()) {
                this.set('state', SyncStateModel.States.synced);
            }
        },

        isConflict: function() {
            return this._models.any(function(m) {
                return m.isConflict()
            });
        },

        isSyncing: function() {
            return !this.isConflict() &&
                this._models.any(function(m) {
                    return m.isSyncing()
                });
        },

        isUnsync: function() {
            return !this.isConflict() && !this.isSyncing() &&
                this._models.any(function(m) {
                    return m.isUnsync()
                });
        },

        isSynced: function() {
            return !this.isConflict() &&
                !this.isSyncing() &&
                !this.isUnsync();
        }
    });
});



// WEBPACK FOOTER //
// ./system/domain/entity/sync-states.js